import SharedUsageCharts from './shared-usage-charts'

export default SharedUsageCharts